<template>
  <a class="custom-style-block" :href="block.url" target="_blank" rel="noopener noreferrer">
    <img :src="require('@/assets/img/custom-style/custom-style-' + index + '.webp')" alt="" />
    <p class="custom-style-block__title">{{ block.title }}</p>
    <p class="custom-style-block__subtitle">{{ block.description }}</p>
  </a>
</template>

<script>
export default {
  name: 'CustomStyleBlock',
  props: {
    lang: {
      type: String,
      default: 'en',
    },
    index: {
      type: Number,
      default: 0,
    },
    block: {
      type: Object,
      default: null,
    },
  },
};
</script>
